import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaxLoanAmountSelectorComponent } from './max-loan-amount-selector.component';
import { MatInputModule, MatRadioModule } from '@angular/material';
import { FormsModule } from '@angular/forms';

@NgModule({
  exports: [MaxLoanAmountSelectorComponent],
  declarations: [MaxLoanAmountSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatInputModule
  ]
})
export class MaxLoanAmountSelectorModule { }
